//@flow
import React from 'react';
import injectSheet from 'react-jss';
import type { RouterHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { setSessionIdToUrl } from 'h-commons';

const PageNotFound = (props: Props) => {
    const { classes, history, homeUrl } = props;
    const goHome = () => history.push(setSessionIdToUrl(homeUrl, props.userSession));
    return (
        <div className={classes.root}>
            <div className={classes.centered}>
                <img className={classes.errorImage} src={require("../images/hiver-bee2x.png")} />
                <div className={`h-h1 ${classes.subtitle}`}>
                    Page Not Found
                </div>
                <div onClick={goHome} className={`h-s3 ${classes.action}`}>
                    Go Home
                </div>
            </div>
        </div>
    );
}
type Props = {
    classes: Object,
    history: RouterHistory,
    userSession: string | null
}

const style = {
    root: {
        height: '100%',
        minHeight: '65vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    errorImage: {
        height: 260,
        width: 360,
        objectFit: 'content'
    },
    centered: { 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
    },
    subtitle: {
        fontSize: 30,
        color: '#3c5b72',
        marginTop: 20
    },
    action: {
        cursor: 'pointer',
        marginTop: 12,
        color: '#5585a8',
        fontSize: 22,
        '&:hover': {
            textDecoration: 'underline'
        }
    }
}
const mapStateToProps = ({ appModes: { userSession }}) => ({
    userSession
})
export default connect(mapStateToProps)(injectSheet(style)(PageNotFound));